<template>
  <fts-dropdown-select ref="dropdown" class="designer-row-menu-dropdown" content-class="designer-row-menu-dropdown-menu"
    :offset="[0, 6]" @show="openDropdown">
    <template #toggle>
      <slot name="toggle" />
    </template>

    <template #menu>
      <div class="dropdown-list">
        <div class="dropdown-option" v-if="index > 1" @click="confirmSelection('moveTop')">
          <font-awesome-icon class="drag-icon" :icon="['fas', 'arrows-up-to-line']" :width="10" />Move top
        </div>
        <div class="dropdown-option" v-if="index > 0" @click="confirmSelection('moveUp')">
          <font-awesome-icon class="drag-icon" :icon="['fas', 'arrow-up']" :width="10" />Move up
        </div>
        <div class="dropdown-option" v-if="index < totalLength - 1" @click="confirmSelection('moveDown')">
          <font-awesome-icon class="drag-icon" :icon="['fas', 'arrow-down']" :width="10" />Move down
        </div>
        <div class="dropdown-option" v-if="index < totalLength - 2" @click="confirmSelection('moveBottom')">
          <font-awesome-icon class="drag-icon" :icon="['fas', 'arrows-down-to-line']" :width="10" />Move bottom
        </div>
        <div class="dropdown-option danger" @click="confirmSelection('removeRow')">
          <font-awesome-icon class="drag-icon danger" :icon="['fas', 'trash']" :width="10" />Remove row
        </div>
      </div>
    </template>
  </fts-dropdown-select>
</template>


<script>

import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSCheckbox from '../elements/FTSCheckbox';

export default {
  name: 'ImageVariationDropdown',
  components: {
    'fts-toggle-switch': FTSToggleSwitch,
    "fts-dropdown-select": FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup,
    "fts-checkbox": FTSCheckbox,
  },
  emits: ['select'],
  props: {
    index: Number,
    totalLength: Number
  },
  data() {
    return {
    }
  },
  methods: {
    openDropdown() {
    },
    confirmSelection(v) {
      this.$emit('select', v);
      this.$refs.dropdown.$refs.popper.doClose();
    },
  },
};
</script>

<style lang="scss">
.dropdown-option {
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
}


.danger {
  color: var(--fts-danger);
}
</style>
